import { RequestableState, createRequestableState } from '@tock/shared/state/requestableState';
import { consumer, payloadToJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface PlaylistState {
  selectedPlaylist: RequestableState<consumer.Playlist>;
}

const initialState: PlaylistState = {
  selectedPlaylist: createRequestableState(),
};

export default function reducer(
  state: PlaylistState = initialState,
  action: BaseTockAction
): PlaylistState {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.PLAYLIST_FETCH_STARTING: {
      return {
        ...state,
        selectedPlaylist: {
          ...state.selectedPlaylist,
          isRequesting: true,
        },
      };
    }
    case AppConstants.PLAYLIST_FETCH_FAILED: {
      return {
        ...state,
        selectedPlaylist: {
          ...state.selectedPlaylist,
          isRequesting: false,
        },
      };
    }
    case AppConstants.PLAYLIST_FETCH_DONE: {
      return {
        ...state,
        selectedPlaylist: {
          ...state.selectedPlaylist,
          data: payloadToJSON(payload),
          isRequesting: false,
          isInitialized: true,
        },
      };
    }

    default:
      return state;
  }
}
